import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTeams(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('directory/teams', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTeam(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`directory/teams/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
